import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const FeaturesSection = () => {
  return (
    <div className="relative w-full h-[600px] md:h-[700px] flex justify-center items-center bg-transparent text-white overflow-hidden px-2 sm:px-4">

      {/* Central Animation */}
      <div className="w-48 h-48 sm:w-64 sm:h-64 md:w-80 md:h-80 z-10 transition-transform duration-500 ease-in-out hover:scale-110 hover:rotate-3">
        <DotLottieReact
          src="https://lottie.host/63fdc2df-f8cb-48a9-9554-23cc6d1320f0/2LjSOwuxH3.lottie"
          loop
          autoplay
          data-aos="zoom-in"
        />
      </div>

      {/* Floating Labels */}
      <FloatingLabel position="top-[13%] left-[15%]" text="🎨 INSPIRED WITH CREATIVITY" delay="0s" duration="5s" />
      <FloatingLabel position="top-[25%] right-[8%]" text="💻 Design & development craft" delay="1s" duration="6s" />
      <FloatingLabel position="bottom-[22%] left-[18%]" text="🚀 Unlock the potential" delay="2s" duration="5.5s" />
      <FloatingLabel position="bottom-[16%] right-[35%]" text="🔧 Transform ideas into reality" delay="2.5s" duration="6.2s" />
      <FloatingLabel position="top-[35%] left-[7%]" text="🌐 Innovative digital experiences" delay="3s" duration="5.2s" />
      <FloatingLabel position="top-[42%] right-[5%]" text="📣 Empower your brand" delay="3.5s" duration="6.4s" />
      <FloatingLabel position="bottom-[38%] left-[4%]" text="🧠 Smart scalable solutions" delay="4s" duration="5.7s" />
      <FloatingLabel position="top-[10%] right-[35%]" text="🖥️ Next-gen interfaces" delay="4.5s" duration="6.1s" />
      <FloatingLabel position="bottom-[33%] right-[10%]" text="🏭 Digital innovation lab" delay="5s" duration="6.3s" />
    </div>
  );
};

// Label Component with animation + responsive tweaks
const FloatingLabel = ({ position, text, delay = "0s", duration = "6s" }) => (
  <div
    className={`
      absolute ${position}
      text-[6px] xs:text-[7px] sm:text-[8px] md:text-sm
      font-medium
      border border-white/20
      p-[2px] xs:p-[3px] sm:p-[5px] md:p-2
      px-[6px] xs:px-[8px] sm:px-2 md:px-4
      rounded-md
      bg-white/5 backdrop-blur
      animate-hide-seek-float
      z-20
      transition-transform duration-500 ease-in-out 
      hover:scale-105 hover:-rotate-2
      whitespace-nowrap
      max-w-[60vw] sm:max-w-[45vw] md:max-w-none
    `}
    style={{
      animationDelay: delay,
      animationDuration: duration,
    }}
  >
    {text}
  </div>
);


export default FeaturesSection;
